import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  removeError: null,
  setError: ['payload'],
  startLoading: ['payload'],
  stopLoading: ['payload'],
  updateQuantityRequest: ['payload'],
}, { prefix: '[LINE ITEMS] ' });
